// @flow

/*
This content format is used specifically for doc pages that have
sail next UI components (used to document Tailor). We have a separate
file so that we can more easily adjust the styling of component pages.
(For example, we can use the sail theme provider, which adds an extra div
to the DOM, which would mess with CSS styles if we place the provider
higher in the stack.
*/

import React from 'react';
import {Provider as SailNextThemeProvider} from '@sail/theme';

import type {Article} from 'docs/data';

import {RootLayer} from '@sail/ui';
import {MarkdocContent} from './MarkdocContent';

type MarkdocContentProps = {|
  article: Article,
|};

export const TailorComponentUIContent = ({article}: MarkdocContentProps) => {
  return (
    <SailNextThemeProvider id="sail-next-theme-wrapper">
      <RootLayer>
        <MarkdocContent article={article} />
      </RootLayer>
    </SailNextThemeProvider>
  );
};
